<template>
  <CustomFieldListItem
    :call-target-id="callTargetId"
    :custom-field-id="item.id"
    :options="item.options"
    :node="item.name"
    :title="item.name"
    :value="customFieldValue"
    :sf-link="customFieldSfLinkValue"
    :loading="false"
    :type="item.dataType"
    :editable="false"
    hyphen
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { CallTargetCustomField, SalesforceReferenceInfo } from '@/api/openapi';
import CustomFieldListItem from '@/components/organisms/user/lead/detail/CustomFieldListItem.vue';
import { useCustomFieldAttributes } from '@/composable/user/lead/attributes';

type TProps = {
  item: CallTargetCustomField;
  callTargetId: number;
  sfReferenceInfo: Record<string, SalesforceReferenceInfo>;
};

const props = defineProps<TProps>();

const { getCustomFieldValue, getCustomFieldSfLinkValue } = useCustomFieldAttributes(() => props.sfReferenceInfo);

const customFieldValue = computed(() => getCustomFieldValue(props.item));
const customFieldSfLinkValue = computed(() => getCustomFieldSfLinkValue(props.item));
</script>
